<template>
  <NuxtLink
    :to="`/historical-maps/${data.slug}`"
    class="flex flex-col text-new-black"
  >
    <div
      class="mb-[20px] rounded-[12px] bg-white-100 px-[28px] pb-[50px] pt-[36px] shadow-drop-0"
    >
      <MainPageCardsReworkedCommonCardImageBlock
        class="relative max-h-[292px] md:min-h-[292px]"
        :data="data"
        :priority-image="priorityImage"
        disable-label
        no-rounded
      />
    </div>

    <h2 class="text-center font-roboto text-[14px] font-medium leading-[17px]">
      {{ shrinkText(data.title, 200) }}
    </h2>
  </NuxtLink>
</template>

<script setup>
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  priorityImage: { type: String, default: '' },
});
const { shrinkText } = useUtils();
</script>
